module.exports = __webpack_public_path__ + "assets/165fd29e02bc04d59b57af7384b28711.mp3";